import { useRoute } from '@nuxtjs/composition-api';
import urlJoin from 'url-join';
import { useRuntimeConfig } from '~/composables/useRuntimeConfig';
import { karteTrack } from '~/utils';
import { formatKeyValueArray, getProductPrice, getProductType } from '~/utils/modules/products';
import { ProductShowECResponseSchema } from '~/types/modules/product';

export const useKarteItemDetailTag = () => {
  const { FRONTEND_ORIGIN } = useRuntimeConfig();
  const route = useRoute();

  const setKarteItemDetailTag = (ecResponse: ProductShowECResponseSchema) => {
    const {
      attributes,
      best_priced_variant_id,
      categories,
      code,
      is_no_index,
      langs,
      main_image_url,
      master_settings,
      product_variants,
      review_settings,
      type_id,
      size_amount,
    } = ecResponse;

    const formattedAttributes = formatKeyValueArray(attributes);
    const priceSetting = product_variants.find(({ id }) => id === best_priced_variant_id)?.price_settings;
    const productInfo = {
      item_id: code,
      sku_id: '',
      name: langs?.find(({ id }) => id === 'ja')?.name,
      price: priceSetting ? getProductPrice(priceSetting).price : undefined,
      item_url: urlJoin(FRONTEND_ORIGIN, route.value.path),
      image_url: main_image_url,
      review_num: review_settings?.review_total,
      stock_status: product_variants.some((variant) => variant.stock_count),
      item_type: getProductType(type_id),
      parent_category_id: categories[0]?.id,
      parent_category_name: categories[0]?.name,
      category_id: categories[1]?.id,
      category_name: categories[1]?.name,
      area1_id: master_settings.producing_areas[0]?.id,
      area1_name: master_settings.producing_areas[0]?.name,
      area2_id: master_settings.producing_areas[1]?.id,
      area2_name: master_settings.producing_areas[1]?.name,
      area3_id: master_settings.producing_areas[2]?.id,
      area3_name: master_settings.producing_areas[2]?.name,
      producer_id: master_settings.producer?.id,
      producer_name: master_settings.producer?.name_kana,
      item_size: size_amount,
      color_group_id: master_settings.color_group?.id,
      color_group_name: master_settings.color_group?.name,
      color_id: master_settings.color?.id,
      color_name: master_settings.color?.name,
      brand1_id: master_settings.brands[0]?.id,
      brand2_id: master_settings.brands[1]?.id,
      brand3_id: master_settings.brands[2]?.id,
      taste_gauge: Number(formattedAttributes?.taste_gauge),
      sense_type: Number(formattedAttributes?.sense_type),
      taste1: Number(formattedAttributes?.taste_finish),
      taste2: Number(formattedAttributes?.taste_volume),
      taste3: Number(formattedAttributes?.taste_fruity),
      taste4: Number(formattedAttributes?.taste_bitter),
      taste5: Number(formattedAttributes?.taste_robust),
      taste6: Number(formattedAttributes?.taste_sour),
      review_point: review_settings?.rating_average,
      carriage_discount_type: product_variants.some((variant) => variant.price_settings.is_free_shipping)
        ? '送料無料'
        : '',
      list_display_flag: is_no_index ? '非表示' : '表示',
    };
    karteTrack('_view_item', productInfo);
  };

  return { setKarteItemDetailTag };
};
